<template>
	<router-view />
</template>
<script lang="ts" setup>
if (!localStorage.getItem("language")) {
	let language = navigator.language || navigator.userLanguage;
	//英文
	if (language.indexOf("en") >= 0) {
		localStorage.setItem("language", "en");
	} else {
		localStorage.setItem("language", "zh");
	}
}
</script>
<style>
.el-collapse-item__header {
	height: auto !important;
	min-height: 48px;
	text-align: left;
	line-height: 28px !important;
}
html,
body {
	min-height: 100vh;
}
.nc_login {
	border: none !important;
}
.icon {
	width: 1em;
	height: 1em;
	vertical-align: -0.125em;
	fill: currentColor;
	overflow: hidden;
}
</style>
